<!-- TEMPLATE -->
<template>
  <div class="float-right">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="btn btn-icon"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          v-on:click="selectOption(item.id)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<!-- SCRIPT -->
<script>
export default {
  name: "ExportReport",
  data: function () {
    return {
      selectedPeriod: this.$store.state.selectedPeriod,
      items: [
        { title: "Export as CSV", id: "csv" },
        { title: "Export as JSON", id: "json" },
      ],
    };
  },

  methods: {
    selectOption(value) {
      //TODO
      this.$store.dispatch("generateExportReport", value);
    },
  },
};
</script>

<!-- Style -->
<style>
</style>